<section class="wishlist-create-success" aria-label="Wishlista utworzona">
  <p class="success-topline">Gotowe</p>
  <span class="success-check" aria-hidden="true">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m4 12 5 5L20 6" />
    </svg>
  </span>
  <div class="success-intro">
    <span>✦ Sukces</span>
    <h2>Wishlista została utworzona.</h2>
    <p>Możesz dodać kolejne prezenty albo wrócić do listy w każdej chwili.</p>
  </div>

  <button type="button" class="success-card" (click)="handleDetailsSelected()">
    <span class="success-avatar" aria-hidden="true">{{ avatarInitial() }}</span>
    <span class="success-card-copy">
      <strong>{{ wishlistTitle() }}</strong>
      <small>{{ beneficiaryLabel() }} · {{ giftCountLabel() }}</small>
      <span class="success-track" aria-hidden="true"></span>
    </span>
    <span class="success-chevron" aria-hidden="true">›</span>
  </button>

  <p class="success-hint">
    Udostępnianie skonfigurujesz w szczegółach wishlisty.
  </p>

  <div class="success-actions">
    <ui-button [fullWidth]="true" size="lg" (pressed)="handleDetailsSelected()"
      >Przejdź do wishlisty</ui-button
    >
    <ui-button
      [fullWidth]="true"
      size="lg"
      variant="secondary"
      (pressed)="handleAddItemsSelected()"
      >Dodaj prezenty</ui-button
    >
  </div>
</section>
